import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const BlogList = () => {
    const [news, setNews] = useState([]);

    useEffect(() => {
        fetch('https://strapi.ppl.co.id/api/newses?populate=*')
            .then(res => res.json())
            .then(res => {
                if(res.data) setNews(res.data);
            });
    }, []);

    const settings = {
        dots: true,
        infinite: news.length > 3,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: false,
        responsive: [
            { breakpoint: 992, settings: { slidesToShow: 2, infinite: news.length > 2 } },
            { breakpoint: 768, settings: { slidesToShow: 1, infinite: news.length > 1, arrows: false } }
        ]
    };

    return (
        <section className="blog_section section_space bg-light" style={{paddingTop: '100px', overflow: 'hidden'}}>

            {/* INI DIA CSS AJAIBNYA BRAY 👇 Paksa jalurnya jadi flexbox biar tinggi kartu sejajar */}
            <style>{`
                .blog_section .slick-track {
                    display: flex !important;
                }
                .blog_section .slick-slide {
                    height: inherit !important;
                    display: flex !important;
                }
                .blog_section .slick-slide > div {
                    width: 100%;
                    display: flex;
                }
            `}</style>

            <div className="container" style={{ width: '100%', display: 'block', minHeight: '400px' }}>
                {news.length > 0 ? (
                    <Slider {...settings}>
                        {news.map((item, index) => {
                            const mediaItem = item.Media?.[0];
                            const imgUrl = mediaItem?.url
                                           ? `https://strapi.ppl.co.id${mediaItem.url}`
                                           : 'https://via.placeholder.com/400x250';

                            const isVideo = mediaItem?.mime ? mediaItem.mime.startsWith('video/') : imgUrl.match(/\.(mp4|webm|ogg)$/i);

                            const findText = (content) => {
                                if (!content) return "Tidak ada deskripsi";
                                const block = content.find(b => b.children && b.children.length > 0);
                                return block ? block.children[0].text : "Tidak ada deskripsi";
                            };

                            const shortDesc = findText(item.Content);

                            return (
                                // height 100% biar dia ngisi penuh tinggi jalur flexbox tadi
                                <div key={index} style={{ padding: '20px 15px', height: '100%' }}>
                                    <div className="blog_post_block w-full shadow-lg" style={{
                                        background: '#fff',
                                        borderRadius: '10px',
                                        overflow: 'hidden',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        height: '100%', 
                                        minHeight: '380px'
                                    }}>
                                        <div className="blog_img">
                                            {isVideo ? (
                                                <video 
                                                    src={imgUrl} 
                                                    muted 
                                                    playsInline
                                                    style={{width: '100%', height: '220px', objectFit: 'cover', backgroundColor: '#000', display: 'block'}} 
                                                />
                                            ) : (
                                                <img 
                                                    src={imgUrl} 
                                                    alt={item.Title} 
                                                    style={{width: '100%', height: '220px', objectFit: 'cover', display: 'block'}} 
                                                />
                                            )}
                                        </div>
                                        <div className="blog_post_content p-5" style={{
                                            flex: 1,
                                            display: 'flex',
                                            flexDirection: 'column'
                                        }}>
                                            <h3 className="blog_post_title" style={{marginBottom: '10px', fontSize: '20px'}}>
                                                <Link to={`/blog-single/${item.Slug}`}>{item.Title}</Link>
                                            </h3>
                                            <p className="text-gray-600" style={{flex: 1}}>
                                                {shortDesc.length > 100 ? `${shortDesc.substring(0, 100)}...` : shortDesc}
                                            </p>
                                        </div>
                                        {/* marginTop: 'auto' ngunci posisi link biar neken ke bawah terus */}
                                        <div className="p-5 pt-0" style={{ marginTop: 'auto' }}>
                                            <Link to={`/blog-single/${item.Slug}`} className="text-blue-600 font-bold">Selengkapnya →</Link>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </Slider>
                ) : (
                    <div style={{ textAlign: 'center', padding: '50px 0', fontSize: '18px', color: '#666' }}>
                        Loading Berita...
                    </div>
                )}
            </div>
        </section>
    );
}

export default BlogList;
